import { useLocation } from "react-router-dom";
import NavigationCards2 from "components/navigation/navigation-cards/navigation-cards2";

export default function SummaryReportsIndex() {
    const location = useLocation();
    return (
        <NavigationCards2 route={location.pathname} />
    );
}
